import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { SettingsProvider } from './context/SettingsContext';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Packages from './pages/Packages';
import PackageDetail from './pages/PackageDetail';
import Customize from './pages/Customize';
import Contact from './pages/Contact';
import About from './pages/About';
import Privacy from './pages/Privacy';
import DeleteData from './pages/DeleteData';
import NotFound from './pages/NotFound';

import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/Dashboard';
import AdminCategories from './admin/AdminCategories';
import AdminPackages from './admin/AdminPackages';
import AdminAddons from './admin/AdminAddons';
import AdminInquiries from './admin/AdminInquiries';
import AdminContent from './admin/AdminContent';
import AdminSettings from './admin/AdminSettings';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SettingsProvider>
      <Routes>
        {/* Public website */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:id" element={<PackageDetail />} />
          <Route path="/customize" element={<Customize />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/delete" element={<DeleteData />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Admin panel */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/categories" element={<AdminCategories />} />
          <Route path="/admin/packages" element={<AdminPackages />} />
          <Route path="/admin/addons" element={<AdminAddons />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
          <Route path="/admin/content" element={<AdminContent />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
        </Route>
      </Routes>
      </SettingsProvider>
    </BrowserRouter>
  );
}
